import { render, staticRenderFns } from "./ExpensesTable.vue?vue&type=template&id=65e84e90&scoped=true"
import script from "./ExpensesTable.vue?vue&type=script&lang=js"
export * from "./ExpensesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e84e90",
  null
  
)

export default component.exports